// extracted by css-extract-rspack-plugin
export default {"relatedCards":"RelatedResources-module__relatedCards__b8JYF"};